module.exports = __webpack_public_path__ + "img/sankaku_26_red.9ccf733a.png";